export default {
  addKeyModal: {
    action: 'Применить',
    errorMessage:
      'Ошибка применения ключа. Если проблема не устранена, обратитесь в службу поддержки Metrica Sports.',
    minutesMessage: 'Ваш ключ был обработан. Теперь у вас есть %{minutes} минут доступа.',
    placeholder: 'Введите ключ...',
    successMessage: 'Ключ успешно обработан',
    title: 'Добавить ключ'
  },
  admin: {
    NoGames: 'Нет игр, добавьте свою первую...',
    NoResults: 'Нет результатов...',
    addKey: 'Добавить ключ',
    atd: 'ATD',
    automatedTrackingData: 'Данные автоматического Tracking (ATD)',
    automatedTrackingDataJobSuccess:
      'Автоматизированный процесс данных Tracking на %{vpName} завершен и теперь доступен в Metrica PlayBase',
    automatedTrackingDataProcessedTooltip: 'Данные авто Tracking обработаны',
    awayTeam: 'Команда гостей',
    awayTeamScore: 'Счет команды гостей',
    ballDetection: 'Обнаружение мяча',
    ballTracking: 'Tracking мяча',
    ballTrackingProcessedTooltip: 'Обнаружение мяча обработано',
    ballTrackingTooltip:
      'Этот процесс обнаружит мяч и позволит вам визуализировать его внутри Live Formation (2D Pitch) в PlayBase. Координаты мяча также будут доступны в файле формата FIFA EPTS.',
    cancelATDProcessSuccessfully: 'Процесс авто Tracking данных был отменен на %{vpName}',
    cancelDataIntegrationProcessSuccessfully: 'Процесс интеграции данных был отменен на %{vpName}',
    cancelEventsProcessSuccessfully: 'Процесс Smart Tagging был отменен на %{vpName}.',
    cancelProcessTooltip: 'Отменить процесс',
    cancelSurfacesProcessSuccessfully: 'Процесс Surface был отменен на %{vpName}',
    cancelTrackingFifaFormatProcessSuccessfully:
      'Процесс отслеживания формата FIFA был отменен на %{vpName}',
    category: 'Категория',
    checking: 'Проверка...',
    cloudMinutes: 'Минуты GameCloud',
    competition: 'Соревнование',
    connectionFailed: 'Ошибка подключения',
    connectionFailedText:
      'Кажется, возникла проблема с получением информации о состоянии. Пожалуйста, проверьте подключение к Интернету и перезагрузите страницу. Если проблема не устранена, обратитесь в службу поддержки',
    correctedTracking: 'Tracking коррекция в Proцессе',
    correctionUsage: 'Будете ли вы использовать этот видеопProект для коррекции Tracking?',
    correctionUsageTooltip:
      'Tracking Correction Manager (TCM) — это модуль в PlayBase, ориентированный на пользователя, для коррекции треков, ранее созданных с помощью нашего ATD, который автоматически генерирует данные без идентификаторов для любой футбольной игры. Используйте TCM, чтобы исправить неверные треки и присвоить им идентичность. Свяжитесь с нами для получения дополнительной информации.',
    createVideoProject: 'Создать видео проект',
    creatingGame: 'Создание видеоProекта...',
    dataIntegrationFailed:
      'Ошибка интеграции данных на %{vpName}. Перейдите на панель интеграции данных, проверьте файлы и повторите попытку. Если ошибка повторяется, обратитесь в службу поддержки Metrica Sports.',
    dataIntegrationJobSuccess: 'Процесс интеграции данных для %{vpName} успешно завершен',
    date: 'Дата',
    description: 'Описание',
    editedSuccessfully: '%{vpName} успешно отредактировано',
    errorContactSupport: 'Ошибка. Обратитесь в службу поддержки',
    errorProcessTooltip: 'Ошибка в процессе',
    eventsDetection: 'Автоматическая маркировка',
    eventsDetectionProcessedTooltip: 'Smart Tagging обработан',
    eventsDetectionTooltip: {
      footer: '*Доступно для видео длительностью более 30 минут.',
      header:
        'Воспользуйтесь нашей технологией для автоматического обнаружения серии событий, происходящих в игре*.'
    },
    fieldRecognition: 'Обнаружение поля',
    fieldTrackingProcessedTooltip: 'Обнаружение поля обработано',
    fieldTrackingTooltip:
      'Обработка Обнаружения Поля для добавления визуализаций со значениями скорости и расстояния, а также всех рисунков в зависимости от поля в PlayBase.',
    fileDeletedSuccessfully: '%{fileName} успешно удален для %{vpName}',
    fileUploadedError: 'Ошибка загрузки %{fileName} для %{vpName}',
    fileUploadedSuccessfully: '%{fileName} успешно загружен для %{vpName}',
    forkedGameLimit:
      'Этот видеопроект принадлежит другой организации, поэтому его невозможно изменить.',
    gameDeletedSuccessfully: '%{game} успешно удалена',
    gameVideoProject: 'Игровой видео проект',
    getMoreMinutes: 'Получите больше',
    homeTeam: 'Домашняя команда',
    homeTeamScore: 'Счет домашней команды',
    initializing: 'Инициализация ...',
    jobFailed:
      'Не удалось выполнить процесс %{process} для %{vpName}. Обратитесь в службу поддержки Metrica Sports.',
    liveCoding: 'или продолжить кодирование в живом режиме?',
    liveCodingTooltip:
      'Вы можете создать видеопроект, не выбирая видеофайл для целей Coding в живом режиме. Когда у вас есть видео, вы можете добавить его для авто Tracking данных в закодированном видеопроекте.',
    localTeamOnTheLeft:
      'Находится ли "домашняя команда" на левой стороне поля в первой половине игры?',
    localTeamOnTheLeftTooltip:
      'Для proцесса обработки автоматической маркировки укажите, на какой стороне поля находится каждая команда. Посмотрите видео, которое вы загружаете, чтобы проверить его.',
    minutes: '%{minutes} Минут',
    noFootballSideViewTooltip:
      'Этот видеопроект содержит широкоугольный видеофайл, не относящийся к футболу или футболу, или видеофайл, транслируемый по телевидению, поэтому обработано только обнаружение игрока и команды.',
    noMatches: 'Нет совпадений...',
    noSubscriptionOwnerTooltip:
      'Свяжитесь с &#39;%{email}&#39;, администратором вашей подписки, для обновления или перейдите на страницу наших планов, чтобы создать свой собственный план.',
    noVideoFile: 'Нет видеофайла',
    notPossibleToDeleteThisEntry: 'Невозможно удалить эту запись',
    numberOfHalves: 'Сколько таймов в этой игре?',
    numberOfHalvesTooltip:
      'Чтобы выполнить proцесс автоматической маркировки, укажите, сколько игровых периодов включено в загружаемое видео.',
    oldAtdTooltip: 'Это видео было обработано с помощью более старой версии ATD',
    onRequest: 'По запросу',
    organizations: 'Организации',
    place: 'Расположение',
    playerTracking: 'Обнаружение игроков и команд',
    playerTrackingProcessedTooltip: 'Обнаружение игрока обработано',
    playerTrackingTooltip:
      'Этот процесс обнаружит вратарей и 10 полевых игроков каждой команды. Это позволит вам визуализировать Живую Формацию (2D Поле) и автоматически добавлять Визуализации Игроков в PlayBase. Координаты игроков также будут доступны в файле формата FIFA EPTS.',
    postProcessingData: 'Постобработка данных...',
    preProcessingAtd: 'Предварительная обработка...',
    processingTooltip: 'Обработка',
    readyToUpload: 'Готов к загрузке',
    search: 'Поиск...',
    selectVideoFile: 'Выберите видеофайл',
    settingUpAtd: 'Настройка обнаружения...',
    settings: 'Настройки',
    singleVideoProject: 'Одиночный видеопроект',
    startAtd: 'Начать ATD',
    startFifaMessage:
      'Процесс интеграции FIFA для %{vpName} запущен. Мы покажем уведомление, как только это будет сделано. Пожалуйста подождите.',
    startProcessingWaitingJobsFailed: 'Не удалось отправить ожидающие задания',
    startProcessingWaitingJobsSuccessfully: 'Ожидающие задания успешно отправлены',
    startSsMessage:
      'Процесс интеграции второго спектра для %{vpName} запущен. Мы покажем уведомление, как только это будет сделано. Пожалуйста подождите.',
    startStatsMessage:
      'Процесс интеграции статистики для %{vpName} запущен. Мы покажем уведомление, как только это будет сделано. Пожалуйста подождите.',
    startTracabDflMessage:
      'Процесс интеграции Tracab DFL для %{vpName} запущен. Мы покажем уведомление, как только это будет сделано. Пожалуйста подождите.',
    startTracabMessage:
      'Процесс интеграции Tracab для %{vpName} запущен. Мы покажем уведомление, как только это будет сделано. Пожалуйста подождите.',
    surfacesJobSuccess: 'Процесс Surface%{vpName} успешно завершен',
    trackingCorrectionProcessedTooltip: 'Tracking коррекция Proведена',
    trackingFifaFormatJobSuccess:
      'Процесс отслеживания формата FIFA для %{vpName} успешно завершен. Теперь вы можете загрузить файл, щелкнув пункт меню «Загрузить формат FIFA».',
    trackingLicence: 'У вас нет лицензии на Tracking',
    uncaughtErrorRow:
      'Ошибка видеопроекта. Пожалуйста, обновите эту страницу. Если проблема не устранена, обратитесь в службу поддержки или удалите ее и создайте заново.',
    updatingGame: 'Обновление видеоProекта...',
    upgradePlan: 'Перейти на новый тарифный план',
    uploadAndTracking: 'Загрузка и Tracking',
    uploadingVideoFile: 'Загрузка видеофайла',
    videoFile: 'Видеофайл',
    videoFootballSideView:
      'Является ли этот видеофайл футбольным широкоугольным видео или телевизионной трансляцией?',
    videoFootballSideViewTooltip: 'Обнаружение поля оптимизировано только для таких видео.',
    videoMultipartStart:
      '%{videoName} загружается на %{vpName}. НЕ ЗАКРЫВАЙТЕ ЭТУ СТРАНИЦУ, пока загрузка не будет завершена',
    videoPlaylist: 'Является ли этот видеофайл плейлистом?',
    videoPlaylistTooltip:
      'Если вы выберете ДА, будет выполнена функция Clip Detection, чтобы определить, когда происходит смена кадра в видео, что делает ее идеальным инструментом, если вы загружаете видео, содержащее несколько клипов, например. После выполнения этого процесса загрузите Видеопроект в PlayBase, и там будет файл Coding Clip Detection с кодом, включающим каждую смену кадра как событие.',
    videoProjectSettings: 'Настройки видеопроекта',
    videoUploadError:
      'Не удалось загрузить видео %{videoName} для %{vpName}. Пожалуйста, попробуйте еще раз',
    videoUploaded: '%{videoName} было загружено на %{vpName}',
    vpCreated: '%{vpName} создан',
    waitingAtd: 'Ожидание...'
  },
  billing: {
    address: 'Адрес',
    billed: 'Выставлено к оплате',
    completed: 'Оплачено',
    details: 'Детали Биллинга',
    history: 'История выставления счетов',
    invoiceNotFound: 'Счет-фактура не найдена',
    noInvoices: 'Нет счетов-фактур',
    past_due: 'Просрочено',
    taxId: 'Идентификационный номер налогоплательщика'
  },
  checkout: {
    chargeSubscription: 'Начислить на подписку',
    costOneTime: '%{currency} %{cost}',
    costRecurrent: '%{currency} %{cost} %{cycle}',
    discountCodes: '*Промокоды можно применять при оформлении заказа.',
    dueToday: 'К оплате сегодня',
    excTax: '(Без учета налогов)',
    halfYear: '6 месяцев',
    halfYearlyBilled: 'Выставляется счёт каждые 6 месяцев',
    immediatePayment: 'Немедленный платеж',
    incTax: '(Вкл. налог)',
    month: 'месяц',
    monthlyBilled: 'Ежемесячная оплата',
    nextPayment: 'Следующий Платеж',
    noPacks: 'Без Минут GameCloud',
    onDate: '%{date} числа',
    packs: 'Пакеты',
    packsTotal: 'Всего Пакетов',
    perHalfYear: '/6 месяцев',
    perMonth: '/месяц',
    perYear: '/год',
    plans: 'Планы',
    plansTotal: 'Общее количество планов',
    proceed: 'Перейти к оплате',
    subtotal: 'Субтотал',
    taxPayable: 'Налоги (%{percentage}%)',
    total: 'Всего',
    unpaid:
      'Ваш последний счет еще не был оплачен. Пожалуйста, обновите вашу платежную информацию, чтобы продолжить.',
    updatePaymentMethod: 'Обновить способ оплаты',
    updateSubscription: 'Обновить подписку',
    upgradeTo: 'Обновить до %{plan}',
    userDevice: '1 пользователь/устройство',
    usersDevices: '%{number} пользователей/устройств',
    year: 'год',
    yearlyBilled: 'Ежегодно выставляется счет'
  },
  common: {
    add: 'Добавить',
    back: 'Назад',
    cancel: 'Отмена',
    canceling: 'Отмена ...',
    clearAll: 'Очистить всё',
    continue: 'Продолжить',
    create: 'Создать',
    deactivate: 'Деактивировать',
    edit: 'Редактировать',
    email: 'Электронная почта',
    errorMsg: 'Ошибка обработки %{name}. По вопросам обращайтесь в службу поддержки.',
    errorTryAgain: 'Ошибка. Попробуйте еще раз',
    genericError: 'Ошибка, процесс не выполнен. По вопросам обращайтесь в службу поддержки.',
    loading: 'Загружается ...',
    login: 'Войти',
    logout: 'Выйти',
    new: 'Новый',
    next: 'Следующий',
    no: 'Нет',
    noFileChosen: 'Файл не выбран',
    ok: 'ОК',
    pending: 'ожидающий',
    required: 'Обязательное поле',
    reset: 'Сброс пароля',
    restart: 'Перезапустить',
    save: 'Сохранить',
    selectFile: 'Выбрать файл',
    sort: 'Сортировать',
    start: 'Начать',
    today: 'Сегодня',
    unassigned: 'Не назначено',
    uploading: 'Загрузка...',
    yes: 'да'
  },
  confirmModal: {
    description: 'Вы уверены?',
    title: 'Подтвердить'
  },
  container: {
    download: 'Скачать файл Container',
    notProcessed: 'Файл контейнера не был обработан в этом Видео Проекте.',
    processed: 'Обработанный файл контейнера',
    title: 'Контейнер',
    titleDownload: 'Скачать Контейнер'
  },
  dataIntegration: {
    deleteFile: 'Удалить файл',
    featureNotAvailable:
      'Эта функция недоступна в вашем текущем тарифном плане. Вам нужно перейти на другой план, чтобы иметь эту функцию. Для получения более подробной информации свяжитесь с нами',
    notSideView:
      'Интеграция данных недоступна для видеопроектов, содержащих широкоугольный или телевизионный видеофайл, не относящийся к футболу.',
    open: 'Интеграция открытых данных',
    processJobsFirst:
      'Вам необходимо сначала начать обработку данных авто Tracking (ATD), прежде чем получить доступ к панели интеграции данных.',
    processed: 'Интеграция данных обработана',
    selectFile: 'Выбрать файл',
    startProcess: 'Начать процесс',
    title: 'Интеграция данных',
    waiting: 'Процесс ожидания...',
    waitingProcess:
      'Процесс интеграции начнется после завершения процессов обнаружения игроков и полей.'
  },
  deleteModal: {
    checkboxLabel: 'Я также хочу перестать получать электронные письма от Metrica Sports',
    confirmationType: 'Введите %{validateFormKey} для подтверждения:',
    deleteAction: 'Да, удалить',
    description: 'Вы уверены, что хотите навсегда удалить свою учетную запись?',
    information:
      'Вы потеряете все видеопроекты, созданные с помощью этой учетной записи. Мы не сможем восстановить их после удаления.',
    keepAccount: 'Сохранить аккаунт',
    suggestion: 'Мы предлагаем сохранить ваш аккаунт.',
    title: 'Удалить навсегда?',
    validateFormKey: 'УДАЛИТЬ'
  },
  error: {
    oops: 'Ой!',
    restart: 'Похоже, вы пытаетесь воспользоваться тем, что мы всё еще разрабатываем...'
  },
  eventsDetection: {
    automaticVp: 'Smart Tagging недоступен в Видео Проектах с более старой версией ATD.',
    download: 'Скачать события Smart Tagging в формате XML',
    needsAtd: 'Сначала запустите процесс ATD, чтобы выполнить процесс Smart Tagging.',
    needsFootballSideView:
      'Smart Tagging недоступен в Видео Проектах, содержащих видеофайл, не относящийся к футболу, снятый с широкоугольного ракурса или телевизионной трансляции.',
    needsGameVp: 'Smart Tagging доступен только в проектах видео игр.',
    needsNoPlaylist:
      'Smart Tagging недоступен в Видео Проектах, содержащих файл видео в форме плейлиста.'
  },
  forgotPassword: {
    adminNoResetPassword:
      'Admin пользователи должны использовать частную конечную точку для сброса пароля',
    notFound:
      'Пользователь не найден. Пожалуйста, попробуйте еще раз, указав действительный адрес электронной почты',
    success: 'Восстановление пароля! Пожалуйста, проверьте свою электронную почту'
  },
  groups: {
    addMembers: 'Добавить участников',
    addOrUpdateErrorMessage:
      'Ошибка при обработке группы. Если проблема не исчезнет, свяжитесь с командой поддержки Metrica Sports',
    availableMinutes: 'Доступные Минуты',
    availableMinutesWarning:
      'У вас есть %{availableMinutes} минут, чтобы назначить какой-либо организации',
    createGroup: 'Создать Группу',
    deleteErrorMessage:
      'Ошибка при удалении группы. Если проблема не исчезнет, свяжитесь с командой поддержки Metrica Sports',
    deleteGroup: 'Удалить Группу',
    deleteGroupDescription:
      'Вы пытаетесь удалить группу %{pre}%{name}%{post}. Если к этой группе привязан какой-либо Video Project, пользователи больше не смогут получить к нему доступ.',
    deleteNow: 'Удалить сейчас',
    deleteThisGroup: 'Удалить эту группу',
    editGroup: 'Редактировать Группу',
    enterEmails: 'Введите адреса электронной почты пользователей, которых вы хотите добавить',
    enterGroupName: 'Введите название группы',
    enterValidName: 'Пожалуйста, введите действительное имя',
    gameCloudMinutes: 'Минуты GameCloud',
    groupMembers: 'Члены группы',
    groupName: 'Название группы',
    manageGameCloudMinutes: 'Управление Минутами GameCloud',
    minutesErrorMessage:
      'Ошибка при управлении минутами. Если проблема не исчезнет, свяжитесь с командой поддержки Metrica Sports',
    moreLicensesDescription:
      'Чтобы добавить пользователей с лицензией в ваш аккаунт, пожалуйста, приобретите больше лицензий',
    name: 'Название Группы',
    noMultiLicenseDescription: 'Только планы с мульти-лицензиями могут создавать группы',
    noPermissionDescription:
      'Ваш пользователь принадлежит к организации %{pre}%{ownerEmail}%{post}, свяжитесь с владельцем для обновления или внесения любых изменений'
  },
  login: {
    clickHere: 'Нажмите здесь',
    contactUs: 'Связаться с нами',
    dontHaveAccount: 'У меня нет аккаунта. %{pre}Зарегистрируйтесь%{post}',
    enterYourEmail: 'Введите адрес электронной почты',
    enterYourPassword: 'Введите свой пароль',
    forgotPassword: 'Я забыл свой пароль. %{pre}Нажмите здесь%{post}',
    invalidEmail: 'Неверный адрес электронной почты',
    licenceExpired: 'Срок действия вашей лицензии истек.',
    trialExpired: 'Срок действия пробной версии истек.',
    upgradePlan: 'Обновите свой план'
  },
  patterns: {
    delete: 'Удалить файл шаблона',
    title: 'Пользовательский файл шаблона',
    upload: 'Загрузить файл пользовательского шаблона',
    uploaded: 'Файл шаблона загружен',
    uploading: 'Загрузка файла шаблона'
  },
  plans: {
    academic: 'Академический',
    addMoreProducts: '+ Добавить больше продуктов',
    admin: 'Администратор',
    basic: 'Basic',
    basicCodePadMonthly: 'Basic+Code Ежемесячно',
    basicCodePadYearly: 'Basic+Code Eжегодно',
    basicMftCodePadMonthly: 'Full Basic Ежемесячно',
    basicMftCodePadYearly: 'Full Basic Eжегодно',
    basicMftMonthly: 'Basic+MFT Eжемесячно',
    basicMftXmlMonthly: 'Basic MFT + XML Ежемесячно',
    basicMftXmlYearly: 'Basic MFT + XML Ежегодно',
    basicMftYearly: 'Basic+MFT Ежегодно',
    basicMonthly: 'Basic Ежемесячно',
    basicXmlMonthly: 'Basic XML Ежемесячно',
    basicXmlYearly: 'Basic XML Ежегодно',
    basicYearly: 'Basic Ежегодно',
    code: 'Code',
    elite: 'Elite',
    elite2024Yearly: 'Элита Годовой',
    eliteYearly: 'Elite Ежегодно',
    essentialsCodeMonthly: 'Essentials + Code ∞ Ежемесячно',
    essentialsCodeYearly: 'Essentials + Code ∞ Годовой',
    essentialsMftCodeMonthly: 'Полный пакет Essentials Ежемесячно',
    essentialsMftCodeYearly: 'Full Essentials Годовой',
    essentialsMftMonthly: 'Essentials + MFT Ежемесячно',
    essentialsMftYearly: 'Essentials + MFT Ежегодно',
    essentialsMonthly: 'Essentials Ежемесячно',
    essentialsYearly: 'Essentials Ежегодный',
    influencer: 'Инфлюенсер',
    lite: 'Lite',
    liteMonthly: 'Lite Ежемесячно',
    liteYearly: 'Lite Ежегодно',
    minutes10: '10 Минут GameCloud',
    minutes100: '100 Минут GameCloud',
    minutes1000: '1.000 Минут GameCloud',
    minutes10000: '10.000 Минут GameCloud',
    plan: '%{planName} План',
    planHalfYearly: 'План %{planName} на Полгода',
    planMonthly: 'Ежемесячный План %{planName}',
    planYearly: 'Годовой План %{planName}',
    primeLiveMonthly: 'Prime + Live Ежемесячно',
    primeLiveYearly: 'Prime + Live Ежегодный',
    primeMftLiveMonthly: 'Prime + MFT + Live Ежемесячно',
    primeMftLiveYearly: 'Prime + MFT + Live Ежегодный',
    primeMftMonthly: 'Prime + MFT Ежемесячно',
    primeMftYearly: 'Prime + MFT Ежегодно',
    primeMonthly: 'Prime Ежемесячно',
    primePresetsLiveMonthly: 'Prime + Presets + Live Ежемесячно',
    primePresetsLiveYearly: 'Prime + Presets + Live Ежегодный',
    primePresetsMftLiveMonthly: 'Полный Prime Ежемесячно',
    primePresetsMftLiveYearly: 'Full Prime Годовой',
    primePresetsMftMonthly: 'Prime + Presets + MFT Ежемесячно',
    primePresetsMftYearly: 'Prime + Presets + MFT Ежегодный',
    primePresetsMonthly: 'Prime + Presets Ежемесячно',
    primePresetsYearly: 'Prime + Presets Ежегодно',
    primeYearly: 'Prime Ежегодный',
    pro: 'Pro',
    pro2024LiveMonthly: 'Pro + Live Ежемесячно',
    pro2024LiveYearly: 'Pro + Live Ежегодный',
    pro2024Monthly: 'Про Ежемесячно',
    pro2024Yearly: 'Про Годовой',
    proYearly: 'Pro Ежегодно',
    starter: 'Starter',
    starterCodeMonthly: 'Starter + Code ∞ Ежемесячно',
    starterCodePadMonthly: 'Code Ежемесячно',
    starterCodePauseMonthly: 'Полный Стартер Ежемесячно',
    starterCodePauseYearly: 'Полный Стартовый Годовой',
    starterCodeYearly: 'Starter + Code ∞ Годовой',
    starterPauseMonthly: 'Starter + Pause ∞ Ежемесячно',
    starterPauseYearly: 'Starter + Pause ∞ Годовой',
    student: 'Студент',
    trial: 'Пробная версия'
  },
  playlist: {
    download: 'Загрузить файл плейлиста',
    notProcessed: 'Файл из плейлиста не был обработан в этом видеоProекте.',
    processed: 'Файл из плейлиста proобработан',
    title: 'Плейлист',
    titleDownload: 'Скачать плейлист'
  },
  products: {
    addOns: 'Дополнения',
    basic: 'Безлимитные Коды и Аннотации',
    code: 'CodePad',
    elite: {
      description:
        'Автоматизируйте и настройте весь ваш рабочий процесс анализа. Этот план включает полный доступ к PlayBase со всеми функциями плана "Full Essentials" и доступ к Metrica Nexus со всеми функциями плана "Pro".',
      feature1: '✓ Общее облачное хранилище',
      feature2: '✓ Интеграция данных Tracking',
      feature3: '✓ Менеджер Коррекции Трекинга',
      feature4: '✓ RESTful API'
    },
    essentials: {
      addon1: 'Неограниченные возможности Coding (CodePad, Живое Coding и Импорт XML)',
      addon2: 'Ручное Полевое Трекинг',
      essentialsCodeDescription:
        'Этот план активирует Динамические Телестраторы, позволяя добавлять неограниченное количество визуализаций движений при воспроизведении видео и на паузах. Этот план не включает Ручное Отслеживание Поля, поэтому визуализации Скорости и Дистанции не включены. Также снимается ограничение на функции кодирования, такие как CodePad, Живое Кодирование и Импорт XML, и убирается лимит в 4 кода на Видеопроект, делая количество кодов неограниченным.',
      essentialsDescription:
        'Этот план позволяет использовать Динамическую Телестрацию, доступную для добавления неограниченных визуализаций движения при воспроизведении видео и на паузах. Этот план не включает Ручное Отслеживание Поля, поэтому визуализации Скорости и Дистанции не включены. Возможности кодирования остаются ограниченными.',
      essentialsMftCodeDescription:
        'Этот план активирует возможность Динамической Телестрации, позволяя добавлять неограниченное количество визуализаций движений при воспроизведении видео и на паузах, а также включает Мануальное Полевое Трекинг для добавления визуализаций скорости и расстояний. Также снимает ограничение на функции кодирования, такие как CodePad, Живое Кодирование и Импорт XML, и убирает лимит в 4 кода на Видеопроект, делая количество кодов неограниченным.',
      essentialsMftDescription:
        'Этот план включает возможность использования Динамической Телестрации, позволяя добавлять неограниченное количество визуализаций движения при воспроизведении видео и на паузах, а также активирует Ручное Отслеживание Поля для добавления визуализаций скорости и расстояния. Возможности кодирования остаются ограниченными.',
      feature1: '✓ Постигровое кодирование (Code Table с до 4 кодами)',
      feature2: '✓ Неограниченная телестраторная работа в паузах',
      feature3: '✓ Динамическая телестратория'
    },
    featuresIncluded: 'Включенные функции:',
    freeFeature1: '✓ Постигровое кодирование (Code Table с до 4 кодами)',
    freeFeature2: '✓ Ручное трекинг',
    freeFeature3: '✓ Телестратор (до 50 аннотаций)',
    freeFeature4: '✓ Экспорт видео',
    freeFeatures: 'Бесплатные функции',
    fullBasic: 'Ручное Полевое Трекинг',
    lite: 'Автоматическое отслеживание игроков и поля',
    liteDescription:
      'Продвинутое кодирование и продвинутые визуализации. Все автоматически, что делает это в 3 раза быстрее, чем Full Basic!',
    minutesDescription:
      'Пополните любой план. Получите пакеты минут для Автоматизированных Данных Трекинга.',
    minutesPack: 'Пакет Минут GameCloud',
    nexus_elite: {
      description: 'Для лучших команд в мире',
      feature1: '✓ Все функции Pro',
      feature2: '✓ Полный Tracking Клипа',
      feature3: '✓ Nexus Live (Захват В Прямом Эфире + Nexus Мобильный)'
    },
    nexus_prime: {
      addon1: 'Nexus Live (Запись в Прямом Эфире + Nexus Мобильный)',
      description: 'Начальное решение',
      feature1: '✓ Полный Анализ Игры',
      feature2: '✓ Полные Визуализации',
      feature3: '✓ Ручной Tracking'
    },
    nexus_pro: {
      addon1: 'Nexus Live (Захват В Прямом Эфире + Nexus Мобильный)',
      description: 'Автоматизируйте ваш рабочий процесс',
      feature1: '✓ Полный Анализ Игры',
      feature2: '✓ Полные Визуализации',
      feature3: '✓ Автоматический Tracking'
    },
    otherDescription:
      'Расширенные функции coding с базовой телестрацией и ограниченными аннотациями',
    playbase_advanced: {
      description: 'Полностью автоматизированный анализ',
      feature1: '✓ Полный Анализ Игры',
      feature2: '✓ Телестратор в Движении',
      feature3: '✓ Автоматический Tracking'
    },
    playbase_essentials: {
      description: 'Начальное решение',
      feature1: '✓ Полный Анализ Игры',
      feature2: '✓ Телестратор на Паузах'
    },
    playbase_plus: {
      description: 'Tracking на своем собственном темпе',
      feature1: '✓ Полный Анализ Игры',
      feature2: '✓ Телестратор в Движении',
      feature3: '✓ Ручной Tracking'
    },
    prime: {
      addon1: 'Ручное Полевое Трекинг',
      addon2:
        'Предустановленные Визуализации (настройте и сохраните свои собственные визуализации)',
      addon3: 'Живая Запись (захват, анализ и обмен выделенными моментами на ходу)',
      feature1: '✓ Полный доступ к PlayBase со всеми функциями плана "Full Essentials"',
      feature2: '✓ Доступ к Metrica Nexus с:',
      feature2_1: 'Последовательные паузы',
      feature2_2: 'Продвинутая телестраторика',
      feature2_3: 'Пользовательский экспорт видео',
      primeDescription:
        'Этот план включает полный доступ к PlayBase со всеми функциями плана "Essentials + Code ∞" и обеспечивает доступ к Metrica Nexus с продвинутыми телестраторными возможностями.',
      primeMftDescription:
        'Этот план включает полный доступ к PlayBase со всеми функциями плана "Full Essentials" и активирует Metrica Nexus с продвинутыми телеиллюстрациями.',
      primePresetsDescription:
        'Этот план включает полный доступ к PlayBase со всеми функциями плана "Essentials + Code ∞" и активирует Metrica Nexus с продвинутыми телеиллюстрациями и персонализированными визуализациями.',
      primePresetsMftDescription:
        'Этот план включает полный доступ к PlayBase со всеми функциями плана "Full Essentials" и активирует Metrica Nexus с продвинутыми телеиллюстрациями и персонализированными визуализациями.'
    },
    pro: {
      addon1: 'Живая Запись (capture, analyze, и share highlights на ходу)',
      description:
        'Этот план включает полный доступ к PlayBase со всеми функциями плана "Full Essentials" и доступ к Metrica Nexus со всеми функциями плана "Full Prime".',
      feature1: '✓ Автоматическое отслеживание игроков',
      feature2: '✓ Автоматическое Отслеживание Поля',
      feature3: '✓ Полный доступ к PlayBase со всеми функциями плана "Full Essentials"',
      feature4: '✓ Доступ к Metrica Nexus с:',
      feature4_1: 'Последовательные паузы',
      feature4_2: 'Продвинутая телестраторика',
      feature4_3: 'Пользовательский экспорт видео',
      feature4_4:
        'Предустановленные Визуализации (настройте и сохраните свои собственные визуализации)'
    },
    remove: 'Удалить',
    starter: {
      addon1: 'Безлимитная телестраторная визуализация в паузах',
      addon2: 'Неограниченные возможности Coding (CodePad, Живое Coding и Импорт XML)',
      feature1: '✓ Постигровое кодирование (Code Table с до 4 кодами)',
      feature2: '✓ Телестратор в паузах (до 50 аннотаций в месяц)',
      feature3: '✓ Экспорт видео',
      starterCodeDescription:
        'Этот план снимает ограничение на функции кодирования, такие как CodePad, Живое Кодирование и Импорт XML. Также убирается ограничение в 4 кода на Видеопроект, делая количество кодов неограниченным. Ограничения на функции телестратора остаются, как в Free Starter.',
      starterCodePauseDescription:
        'Этот план снимает ограничение на функции кодирования, такие как CodePad, Живое Кодирование и Импорт XML. Также он убирает ограничение в 4 кода на Видео Проект, делая их количество неограниченным, и снимает ограничение на телестрации в паузах с 50 в месяц до неограниченного количества.',
      starterPauseDescription:
        'Этот план снимает ограничение на телестратор в паузах с 50 в месяц до неограниченного. Ограничения на функции coding остаются как в Free Starter.'
    },
    totalPack: '%{currency} %{cost}'
  },
  settings: {
    billing: 'Биллинг',
    billingSettings: 'Платежные настройки',
    billingSettingsDescription: '(измените свой план, обновите способы оплаты...)',
    cancelAt: 'Ваш план заканчивается',
    cancelPlan: 'Отменить план',
    confirmNewPassword: 'Подтвердите новый пароль',
    deleteAccount: 'Удалить аккаунт',
    details: 'Мои данные',
    devices: 'Устройства',
    devicesResetError: 'Ошибка сброса устройств. Пожалуйста, попробуйте снова',
    devicesResetSuccess: 'Все ваши устройства были успешно сброшены',
    emailNotActivated: 'Уведомление по электронной почте теперь активировано',
    emailNotDeactivated: 'Уведомление по электронной почте отключено',
    emailNotifications: 'Уведомления по электронной почте',
    groups: 'Группы',
    language: 'Язык',
    languageChanged: 'Язык обновлен',
    manualResetDevices: 'Обратитесь в поддержку для сброса ваших устройств',
    newPassword: 'Новый пароль',
    noDevicesToReset: 'Нет устройств для сброса',
    noOwner:
      'Ваш план принадлежит организации %{pre}%{email}%{post}, свяжитесь с владельцем для обновления или внесения любых изменений',
    organizationLabel: 'Префикс организации',
    organizationTooltip:
      'Этот префикс необходим для импорта пользовательских шаблонов в видеопроект. Свяжитесь с нами для получения дополнительной информации или ознакомьтесь с документацией на codeball.metrica-sports.com',
    passwordsDontMatch: 'Пароли не совпадают',
    passwordInvalid: 'Пароль не соответствует требованиям',
    passwordRequirements: {
      minLength: 'Не менее %{count} символов',
      uppercase: 'Одна заглавная буква',
      lowercase: 'Одна строчная буква',
      number: 'Одна цифра (0-9)',
      maxLength: 'Максимальное число символов: %{count}'
    },
    pauseAt: 'Ваш план приостанавливается %{date}.',
    planCanceled:
      'Ваш план отменен. Проверьте свою электронную почту для получения дополнительной информации',
    plans: 'Планы',
    quantity: 'Количество:',
    remainingResets: '%{current}/%{max} переключений осталось на этот год',
    renewAt: 'Ваш план продлевается на',
    resetDeviceAction: 'Сброс Устройств',
    title: 'Настройки',
    upgradePlan: 'Перейти на новый тарифный план',
    userKey: 'Пользовательский ключ:',
    userKeyUsages: '%{current}/%{max} использований',
    userSettings: 'Пользовательские настройки',
    users: 'Пользователи'
  },
  shoppingCart: {
    subtitle:
      'Выберите ваш план Metrica Sports и дополнения для повышения вашей производительности.',
    title: 'Настройте ваш Metrica Sports'
  },
  subscription: {
    cancelSubscription: 'Отменить подписку',
    errorUpdating:
      'При обновлении вашей подписки произошла ошибка. Пожалуйста, отправьте электронное письмо на адрес support@metrica-sports.com, и мы с удовольствием поможем вам.',
    free: 'Бесплатно',
    isObsolete:
      'Ваша подписка не может быть изменена. Замените устаревшие продукты на новые, чтобы внести изменения',
    pendingRefundRequest:
      'Нельзя вносить дополнительные изменения в эту подписку, пока есть нерассмотренный запрос на возврат средств.',
    planMigrationMessage:
      "С 1 апреля ваша подписка <strong>%{currentPlan}</strong> будет называться <strong>%{newPlan}</strong>, но с вас ничего не будет взиматься. От вас не требуется никаких действий. <strong>%{date}</strong>, цена вашего плана составит <strong>%{newPrice}</strong> за пользователя, за <strong>%{cycle}</strong>. Чтобы узнать больше о всех новых планах <a href='%{link}'>нажмите здесь</a>.",
    undoCancel: 'Отменить отмену подписки',
    undoPause: 'Отменить приостановку подписки',
    updatePaymentMethod: 'Обновить способ оплаты',
    updatedSuccessfully: 'Подписка успешно обновлена.',
    yourPlans: 'Ваши Планы',
    yourSubscription: 'Ваша подписка'
  },
  successfulPayment: {
    addUsers: 'Добавьте других пользователей в вашу организацию.',
    allTheBest: 'Всего наилучшего,',
    applyKey: 'Применить ключ к этому аккаунту',
    applyKeyDescription: 'Хотели бы вы активировать эту лицензию для вашего аккаунта?',
    assignLicenses: 'Перенесите вашу лицензию на другой аккаунт.',
    download:
      'Перейдите на %{pre}Страницу Загрузок%{post} на нашем сайте и скачайте PlayBase или Nexus, в зависимости от вашей лицензии.',
    faq: 'Вот как быстро начать и другая соответствующая информация:\n',
    happyPlay:
      'Мы надеемся, что все понятно, но, пожалуйста, не стесняйтесь обращаться к нам, если у вас есть дополнительные вопросы или сомнения.',
    helpCenter:
      'Посетите наш %{pre}Центр Помощи%{post} для множества полезных статей, таких как полные учебники и часто задаваемые вопросы.',
    howToCancel:
      'Пожалуйста, обратите внимание, что ваша подписка автоматически продлевается до тех пор, пока она не будет %{pre}явно отменена через настройки GameCloud%{post}, в соответствии с нашими Условиями использования.',
    keyApplied: 'Ключ применён',
    licenseActivation1:
      'Если у вас еще не было активной лицензии для вашего аккаунта, ваша вновь приобретенная лицензия была активирована автоматически.',
    licenseActivation2:
      'Если ваша лицензия по какой-либо причине не была активирована, вы можете активировать её ниже:',
    licenseKey: 'Ваш ключ лицензии: %{pre}%{licenseKey}%{post}.',
    licensesTitle: 'Активация лицензии',
    metricaSportsTeam: '— Команда Metrica Sports',
    minutesInfo:
      'Если вы хотите распределить ваши минуты GameCloud между различными группами пользователей, перейдите на вкладку Группы внутри %{pre}Страницы Настроек%{post}.',
    minutesTitle: 'Ваши Минуты GameCloud',
    renewalInfo:
      'Пожалуйста, обратите внимание, что ваша подписка автоматически продлевается до тех пор, пока она не будет %{pre}явно отменена через настройки GameCloud%{post}, в соответствии с нашими Условиями использования.',
    settingsCloud: 'Посетите наш %{pre}GameCloud%{post} и перейдите в меню Настройки, чтобы:',
    technicalSupport: 'Для технической поддержки, %{pre}свяжитесь с нами%{post} напрямую.',
    thanks: 'Спасибо за ваш заказ, мы успешно его обработали!',
    title: 'Подтверждение заказа',
    updatePayment: 'Обновите ваш способ оплаты.',
    updateSubscription: 'Отмените или измените вашу подписку.'
  },
  surfaces: {
    automaticVp: 'Поверхности, недоступные в видеопроектах с более старой версией ATD',
    delete: 'Удалить файл Surface',
    needsAtd: 'Сначала запустите процесс ATD, чтобы запустить процессы Surface.',
    needsElite:
      'Пользовательские поверхности доступны в плане Elite. Для получения более подробной информации свяжитесь с нами',
    needsFootballSideView:
      'Поверхности, недоступные в видеопроектах, содержащих широкоугольный видеофайл, не относящийся к футболу, или видеофайл телетрансляции.',
    pitchControl:
      'Запуск этого процесса позволит вам добавить визуализацию Pitch Control в PlayBase.',
    pitchControlProcessed: 'Поверхность управления полем обработана',
    pitchControlProcessing: 'Обработка управления полем',
    processed: 'Файл Surface загружен',
    processing: 'Обработка файла Surface',
    title: 'Поверхности',
    titlePitchControl: 'Управление полем',
    upload: 'Загрузите свою поверхность',
    uploading: 'Загрузка поверхности...'
  },
  trackingFifaFormat: {
    download: 'Скачать файл формата FIFA EPTS',
    needsElite:
      'Эта функция доступна только после импорта соответствующих файлов в модуль интеграции данных, видеопроекты с автоматическим Tracking данных или видеопроекты в плане Elite.',
    processed: 'Обработан формат FIFA EPTS',
    start:
      'Запустите процесс создания файла формата FIFA EPTS. После этого вы сможете скачать файл',
    title: 'Формат FIFA EPTS',
    titleDownload: 'Скачать формат FIFA EPTS'
  },
  upgradeModal: {
    linksDescription: 'Получите пакет минут GameCloud, который лучше всего подходит вам:',
    minutePackLinks: {
      minutes_10: 'Получите 10 минут за 10 евро',
      minutes_100: 'Получите 100 минут за 90 евро',
      minutes_1000: 'Получите 1000 минут за 750 евро',
      minutes_10000: 'Получите 10 000 минут за 5 000 евро'
    },
    noMinutes: {
      description:
        'У вас недостаточно минут для создания этого видеопроекта. Знаете ли вы, что вы можете получить пакеты минут независимо от вашего плана?',
      secondDescription: '',
      title: 'Получите больше минут для создания видеопроекта!'
    },
    notEnoughMinutes: {
      description: 'Сожалеем, что у вас недостаточно минут для процесса ATD в ваших видеопроектах.',
      secondDescription:
        'Если вы хотите обработать ATD, вам нужно будет добавить больше минут к своей учетной записи. Минуты, которые вы получите, не сгорают!',
      title: 'Недостаточно минут'
    }
  },
  users: {
    addEmails: 'Добавить пользователей с их адресами электронной почты',
    addErrorMessage:
      'Ошибка при добавлении пользователей. Если проблема не исчезнет, свяжитесь с командой поддержки Metrica Sports',
    addUsers: 'Добавить Пользователей',
    availableLicenses: '%{planName} (%{count} доступно%{renewal})',
    currentLicense: '%{planName} (текущий%{renewal})',
    deactivateErrorMessage:
      'Ошибка деактивации пользователя. Если проблема не исчезнет, свяжитесь с командой поддержки Metrica Sports',
    deactivateNow: 'Отключить сейчас',
    deactivateUser: 'Деактивировать Пользователя',
    deactivateUserDescription:
      'Вы пытаетесь деактивировать пользователя %{pre}%{email}%{post}. Пользователь не сможет получить доступ к каким-либо сервисам Metrica Sports и будет переведен на бесплатный план.',
    editUser: 'Редактировать Пользователя',
    enterGroup: 'Ввести группу',
    exportUsers: 'Экспорт Пользователей',
    filteredUsers: '%{nUsers} из %{totalUsers} пользователей',
    firstName: 'Имя',
    lastName: 'Фамилия',
    plan: 'План',
    renewsOn: ', продлевается %{date}',
    role: 'Роль',
    roles: {
      admin: 'Администратор',
      member: 'Член',
      owner: 'Владелец'
    },
    unlinkErrorMessage:
      'Ошибка при отвязке пользователя. Если проблема не исчезнет, свяжитесь с командой поддержки Metrica Sports',
    unlinkFromYourAccount: 'Отвязать от вашего аккаунта',
    unlinkNow: 'Отвязать сейчас',
    unlinkUser: 'Отвязать Пользователя',
    unlinkUserDescription:
      'Вы пытаетесь отвязать пользователя %{pre}%{email}%{post}. Пользователь не сможет получить доступ к каким-либо сервисам Metrica Sports и будет переведен на бесплатный план.',
    updateErrorMessage:
      'Ошибка при обновлении пользователя. Если проблема не исчезнет, свяжитесь с командой поддержки Metrica Sports',
    useComma: 'Используйте запятую для разделения различных адресов электронной почты',
    userGroups: 'Группы пользователей'
  },
  video: {
    cancelUpload: 'Отменить загрузку',
    delete: 'Удалить видео',
    download: 'Скачать видео',
    title: 'Видеофайл',
    upload: 'Загрузить видео',
    uploaded: 'Видео загружено',
    uploading: 'Загрузка видео'
  },
  videoProject: {
    delete: 'Удалить видеопроект',
    edit: 'Редактировать видео проект',
    processWaitingJobs: 'Обрабатывать ожидающие задания',
    title: 'Видеопроект'
  }
}
